import { cn } from '@/lib/utils';
import { tagChipStyle } from '@/lib/transactions/tags';
import type { TransactionTag } from '@/types';

interface TagPillProps {
  tag: TransactionTag;
  className?: string;
}

/**
 * One tag as applied to a transaction (VER-378): "#nome" through the category
 * `color-mix` chip derivation (theme-reactive). Identical for global and personal
 * tags on purpose — scope only matters in the pickers.
 */
export function TagPill({ tag, className }: TagPillProps) {
  const style = tagChipStyle(tag);
  return (
    <span
      data-testid="tag-pill"
      data-tag={tag.id}
      className={cn(
        'inline-flex max-w-full shrink-0 items-center rounded-full px-2 py-0.5 text-2xs font-semibold',
        className,
      )}
      style={{ backgroundColor: style.backgroundColor, color: style.color }}
    >
      <span className="truncate">#{tag.name}</span>
    </span>
  );
}

/** The "+N" overflow pill after MAX_ROW_TAG_PILLS visible tags. */
export function TagOverflowPill({ count }: { count: number }) {
  return (
    <span
      data-testid="tag-overflow"
      className="inline-flex shrink-0 items-center rounded-full bg-surface-sunken px-1.5 py-0.5 text-2xs font-semibold text-text-tertiary"
    >
      +{count}
    </span>
  );
}
